import { UserManagerUserDetail } from "src/containers/userManager/models/UserManagerUserModel";
import { createEntityModel } from "src/store/models/entity/_shared";

export const CoeDepartmentUserEntityModel =
  createEntityModel<UserManagerUserDetail>();
